<template>
  <div class="container-fluid">
    <nav-header
      :navItems="[
        {
          name: 'Template Jobs',
          link: {
            name: 'Template Jobs',
          },
        },
        {
          name: `${jobTemplate ? jobTemplate.name : 'Template Job'}`,
          link: {
            name: 'Template Job',
            params: {
              name: `${jobTemplate ? jobTemplate.name : 'job'}`,
            },
          },
          closeTab: true,
          disable: !showTemplate,
        },
        {
          name: 'Job Stacks',
          link: {
            name: 'Job Stacks',
          }
        },
        {
          name: `${jobStack ? jobStack.name : 'Job Stack'}`,
          link: {
            name: 'Job Stack',
            params: {
              name: `${jobStack ? jobStack.name : 'job'}`,
            },
          },
          closeTab: true,
          disable: !showJobStack,
        },
        {
          name: `Add Job Stack`,
          link: {
            name: 'Add Job Stack'
          },
          closeTab: true,
          disable: true
        },
        {
          name: `Deploy Job Stack`,
          link: {
            name: 'Deploy Job Stack',
            params:{
              name:  `${jobStack ? jobStack.name : 'job'}`
            }
          },
          closeTab: true,
          disable: true
        },
      ]"
      pretitle="Template Jobs"
      :breadcrumbTitle="true"
      :editMode="editModeStack"
      @nav-close-clicked="closeClick"
      @prevent-navigation="showPopup"
    >
      <template v-slot:breadcrumb-title>
        <nav aria-label="breadcrumb" class="header-title">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a @click="closeClick" href="#" class="h1">Template Jobs</a>
            </li>
            <li class="breadcrumb-item active h1" aria-current="page">
            </li>
          </ol>
        </nav>
      </template>
      <template v-slot:header-button-content>
        <div v-if="currentPage.includes('Job Stack')" class="custom-btn-group">
          <span v-if="editModeStack">
            <button @click.prevent="onSaveClickStack()" class="btn btn-success">Save</button>
            <button @click.prevent="onDeleteClickStack()" class="btn btn-danger">
              Delete
            </button>
            <button @click.prevent="onCancelClickStack()" class="btn btn-secondary">
              Cancel
            </button>
          </span>
          <span v-else-if="!editModeStack && !hideEditBtnStack">
            <button
              type="button"
              @click.prevent="onDeployJobStack()"
              class="btn btn-primary"
            >
              Deploy
            </button>
            <button type="button" @click.prevent="onEditClickStack()" class="btn btn-primary">
              Edit
            </button>
          </span>
          <span v-else-if="hideEditBtnStack">
            <button
              type="button"
              @click.prevent="onCreateJobStack()"
              class="btn btn-primary"
            >
              Create Job Stack
            </button>
          </span>
        </div>    
      </template>
    </nav-header>
    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div>
      <router-view
        :editModeStack="editModeStack"
        :saveJobStack="saveJobStack"
        :cancelClickStack="cancelClickStack"
        v-on:hideEditBtnStack="sethideEditBtnStack"
        v-on:triggerEditModeStack="setEditModeStack"
        v-on:setJobTemplate="setJobTemplate"
        v-on:setJobStack="setJobStack"
        v-on:setShowTemplate="setShowTemplate"
        v-on:setShowJobStack="setShowJobStack"
      >
      </router-view>
    </div>
  </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from "vuex";
export default {
  components: { NavHeader },
  data() {
    return {
      error: null,
      jobTemplate: null,
      cancelClick: false,
      editMode: false,
      currentPage:"",
      saveJobStack: false,
      cancelClickStack: false,
      editModeStack: false,
      hideEditBtnStack: true,
      jobStack:null,
      showTemplate: false,
      showJobStack: false,
      meters:[],
      parameters:[]
    };
  },
  watch: {
    "$route.params.name": {
      handler: function (to, from) {
        if (to) {
          this.sethideEditBtnStack(true);
        } else {
          this.setEditModeStack(false);
          this.sethideEditBtnStack(true);
        }
      },
    },
    "$route" :{
      handler: function (to, from){
        if(to.name && to.name){
          if(to.name !=="Deploy Job Stack")
            this.currentPage= to.name
        }
      },
      immediate: true,
      deep:true
    }
  },
  methods: {
    ...mapActions({
      showModal: "showModal",
      deleteJobStack: "amdp/deleteJobStack",
    }),
    setJobTemplate(job) {
      this.currentPage ="Template Job"
      this.jobTemplate = job;
    },
    setJobStack(job) {
      this.currentPage ="Job Stack"
      this.jobStack = job;
    },
    setShowTemplate(val) {
      this.showTemplate = val;
    },
    setShowJobStack(val) {
      this.sethideEditBtnStack(false);
      this.showJobStack = val;
    },
    closeClick(val ) {
      if(val === 'Job Stack'){
        this.jobStack = null;
        this.showJobStack = false;
          this.$router.push({
          name: "Job Stacks",
        });
      }else{
        this.jobTemplate = null;
        this.showTemplate= false;
        this.$router.push({
          name: "Template Jobs",
        });
      }
    },
    showPopup() {
      var self = this;
      this.showModal({
        component: "confirm",
        data: {
          title: "Save Changes",
          message: `Do you want to save changes ?`,
          async confirm() {
            self.onSaveClickStack();
          },
          async cancel() {
            self.onCancelClickStack();
          },
        },
      });
    },
    sethideEditBtnStack(hideEdit) {
      this.hideEditBtnStack = hideEdit;
    },
    setEditModeStack(mode) {
      this.editModeStack = mode;
      this.successMessage = null;
      this.error = null;
    },
    onEditClickStack() {
      this.setEditModeStack(true);
    },
    onSaveClickStack() {
      this.successMessage = null;
      this.error = null;
      this.saveJobStack = !this.saveJobStack;
      this.setEditModeStack(false);
    },
    onDeleteClickStack() {
      const self = this;
      this.showModal({
        component: "confirm",
        data: {
          title: "Delete Job Stack",
          message: `Are you sure you want to delete ${this.jobStack.name}?`,
          async confirm() {
            try {
              await self.deleteJobStack(self.jobStack.name);
              let toastoptions = {
                message:
                  "Job Stack '" + self.jobStack.name + "' deleted successfully.",
                type: "success",
              };
              self.$store.dispatch("addToast", toastoptions);
              self.$store.dispatch("hideModal");
              self.currentPage ="Job Stacks";
              self.setShowJobStack(false);
              self.$router.push({
                name: "Job Stacks",
              });
            } catch (error) {
              if (error.response && error.response.data.error)
                self.error = error.response.data.error;
              else self.error = error.message;
              return;
            }
          },
        },
      });
    },
    onCancelClickStack() {
      this.cancelClickStack = !this.cancelClickStack;
      this.setEditModeStack(false);
    },
    onCreateJobStack(){
      this.$router.push({
					name: "Add Job Stack",
			});
    },
    onDeployJobStack(){
      let self =this;
      this.currentPage ="Deploy Stack";
      this.$router.push({
					name: "Deploy Job Stack",
          params: {name: self.jobStack.name, data:JSON.stringify(self.jobStack)}
			});
    }
  },
  emits: [
    "triggerEditModeStack",
    "hideEditBtnStack",
    "setJobStack",
  ],
};
</script>

<style scoped>
.custom-btn-group {
  display: flex;
  align-items: center;
}
.btn {
  margin-right: 12px;
}
</style>
